/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
import { CATEGORIES, DEFAULT_PREFS, bootstrapConsent, getStoredConsent, onReopenRequest, saveConsent } from "../utils/consentManager";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState(DEFAULT_PREFS);

  useEffect(() => {
    bootstrapConsent();
    if (!getStoredConsent()) setShow(true);
    return onReopenRequest(() => {
      setPrefs({ ...DEFAULT_PREFS, ...(getStoredConsent()?.prefs || {}) });
      setCustom(true);
      setShow(true);
    });
  }, []);

  const finish = (p, action) => { saveConsent(p, action); setShow(false); setCustom(false); };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] bg-white shadow-2xl" style={{ borderTop: "3px solid #F07B1D" }} role="dialog" aria-modal="false" aria-label="Consentement cookies" data-testid="cookie-banner">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          <div className="flex-1 text-sm text-gray-700 leading-relaxed">
            <p className="font-semibold text-[#003087] mb-1">🍪 Vos préférences en matière de cookies</p>
            <p>
              Sans votre accord, seuls les cookies strictement nécessaires (session, espace apprenant, sécurité, paiement) sont utilisés. Les cookies de mesure d'audience (PostHog), de publicité (Meta Pixel) et d'enregistrement de session ne sont déposés qu'avec votre consentement, retirable à tout moment via « Gérer mes cookies ».{" "}
              <Link to="/confidentialite" className="text-[#003087] underline hover:text-[#F07B1D] font-semibold" data-testid="cookie-learn-more" onClick={() => setShow(false)}>En savoir plus</Link>
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 shrink-0 w-full lg:w-auto">
            <Button variant="outline" onClick={() => finish(DEFAULT_PREFS, "reject_all")} className="border-[#003087] text-[#003087] hover:bg-[#003087]/5 font-bold whitespace-nowrap" data-testid="cookie-reject-all">Tout refuser</Button>
            <Button variant="outline" onClick={() => setCustom((v) => !v)} className="border-gray-300 text-gray-700 hover:bg-gray-50 font-semibold whitespace-nowrap" data-testid="cookie-customize" aria-expanded={custom}>Personnaliser</Button>
            <Button onClick={() => finish({ analytics: true, marketing: true, recording: false }, "accept_all")} className="bg-[#F07B1D] text-white hover:bg-[#D96A0F] font-bold whitespace-nowrap" data-testid="cookie-accept-all">Tout accepter</Button>
          </div>
        </div>

        {custom && (
          <div className="mt-4 border-t border-gray-200 pt-4 grid md:grid-cols-2 gap-3" data-testid="cookie-customize-panel">
            {CATEGORIES.map((c) => (
              <label key={c.id} className="flex items-start justify-between gap-3 p-3 rounded-lg border border-gray-200 bg-gray-50/60">
                <span>
                  <span className="block font-semibold text-sm text-[#003087]">{c.label}{c.locked && <span className="ml-2 text-[10px] uppercase tracking-wider text-gray-500">toujours actif</span>}</span>
                  <span className="block text-xs text-gray-600 mt-0.5">{c.description}</span>
                </span>
                <Switch checked={c.locked ? true : !!prefs[c.id]} disabled={c.locked} onCheckedChange={(v) => setPrefs({ ...prefs, [c.id]: v })} data-testid={`cookie-toggle-${c.id}`} aria-label={c.label} />
              </label>
            ))}
            <div className="md:col-span-2 flex justify-end">
              <Button onClick={() => finish(prefs, "custom")} className="bg-[#003087] hover:bg-[#002366] text-white font-bold" data-testid="cookie-save-prefs">Enregistrer mes choix</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
